(function ($) {
  'use strict';

  var uneroEls = uneroEls || {};
  uneroEls.init = function () {
    uneroEls.$body = $(document.body),
      uneroEls.$window = $(window),
      uneroEls.$header = $('#masthead');
    this.countDown();

  };
  uneroEls.countDown = function () {
    if ($('#unero-countdown-date').length <= 0) {
      return;
    }
    if ($().countdown && $('#unero-countdown-date').length > 0) {
      var currentDay = new Date();
      var offerDay = $('#unero-countdown-date').data('countdown').split('-');
      var offerDay = new Date( offerDay[0], (parseInt(offerDay[1]) - 1), offerDay[2] );
      if(currentDay < offerDay){
        $('#unero-countdown-date').countdown({
          until: offerDay,
          layout: '<div class="flip-wrapper"><ul class="flip "><li class="flip-clock-active"><div class="down"><div class="inn">{dn}</div></div></li></ul><span class="flip-clock-label">{dl}</span></div><div class="flip-wrapper"><ul class="flip "><li class="flip-clock-active"><div class="down"><div class="inn">{hn}</div></div></li></ul><span class="flip-clock-label">{hl}</span></div><div class="flip-wrapper"><ul class="flip "><li class="flip-clock-active"><div class="down"><div class="inn">{mn}</div></div></li></ul><span class="flip-clock-label">{ml}</span></div><div class="flip-wrapper"><ul class="flip "><li class="flip-clock-active"><div class="down"><div class="inn">{sn}</div></div></li></ul><span class="flip-clock-label">{sl}</span></div>'

        });
      }
    }
  };
  $(function () {
    uneroEls.init();
  });

})(jQuery);



